<template>
  <v-row no-gutters class="mobile-panel" style="height: calc(100dvh - 70px); width: 100%">
    <v-col cols="12" class="fill-height">
      <v-row no-gutters style="height: 50px !important" class="px-4 mobile-panel-header" align="center">
        <v-col cols="auto" class="text-body-2 font-weight-medium primary-color">
          {{ $i18n.t('admin.legend') }}
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-icon color="font" size="20" @click="isLegendVisible = false">mdi-close</v-icon>
        </v-col>
      </v-row>
      <v-row no-gutters style="height: calc(100vh - 120px) !important; overflow-y: auto">
        <v-col cols="12">
          <the-legend />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { sync } from 'vuex-pathify';
import TheLegend from '@/components/map/TheLegend';
export default {
  name: 'TheMobileLegend',
  components: { TheLegend },
  computed: {
    isLegendVisible: sync('tools/isLegendVisible'),
  },
};
</script>
